var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6175 15.4793H32.3757V15.4154H18.5007V21.582H27.2134C25.9423 25.1718 22.5267 27.7487 18.5007 27.7487C13.3923 27.7487 9.25065 23.607 9.25065 18.4987C9.25065 13.3904 13.3923 9.2487 18.5007 9.2487C20.8586 9.2487 23.0039 10.1382 24.6373 11.5913L28.9979 7.23066C26.2444 4.66455 22.5614 3.08203 18.5007 3.08203C9.9868 3.08203 3.08398 9.98484 3.08398 18.4987C3.08398 27.0126 9.9868 33.9154 18.5007 33.9154C27.0145 33.9154 33.9173 27.0126 33.9173 18.4987C33.9173 17.465 33.8109 16.456 33.6175 15.4793Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86133 11.323L9.92647 15.0377C11.297 11.6444 14.6162 9.2487 18.5005 9.2487C20.8584 9.2487 23.0037 10.1382 24.6371 11.5913L28.9977 7.23066C26.2442 4.66455 22.5612 3.08203 18.5005 3.08203C12.5789 3.08203 7.44362 6.42514 4.86133 11.323Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 33.9167C22.4822 33.9167 26.1005 32.3928 28.8362 29.9145L24.0647 25.8769C22.5169 27.0494 20.5929 27.75 18.5001 27.75C14.4902 27.75 11.0854 25.1932 9.80277 21.625L4.77539 25.4984C7.32685 30.4911 12.5084 33.9167 18.5001 33.9167Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6168 15.4819H32.375V15.418H18.5V21.5846H27.2127C26.6022 23.309 25.493 24.7959 24.0623 25.8789L24.0646 25.8774L28.8361 29.915C28.4985 30.2218 33.9167 26.2096 33.9167 18.5013C33.9167 17.4676 33.8103 16.4586 33.6168 15.4819Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSmall);
export default __webpack_public_path__ + "static/media/googleSmall.db38dae7e79e9f561376e760b84a7687.svg";
export { ForwardRef as ReactComponent };